import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { MsalProvider, useMsal } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { StyledChart } from './components/chart';
import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/scroll-to-top';



// ----------------------------------------------------------------------

const MainContent = () => {
  const { instance } = useMsal();
 // const activeAccount = instance.getActiveAccount();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ScrollToTop />
            <StyledChart />
            <Router />
          </LocalizationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

const App = ({ instance }) => {
  return (
      <MsalProvider instance={instance}>
        <Provider store={store}>
        <MainContent/>
        </Provider>
      </MsalProvider>
  );
};
export default App;